import { Inline, Stack } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { MouseEvent, useMemo } from 'react';
import { generateGoogleMapDirectionLink } from 'shared/geo/GoogleMapUtils';
import { WebViewLink } from 'shared/routing/WebViewLinks';
import { PostingDistanceDTO } from '../../data/dto/PostingDTO';
import {
  formatLoadDistance,
  PostingLoadDTO,
} from '../../data/dto/PostingLoadDTO';
import { trackLoadboardEvent } from '../LoadboardAnalytics';
import { PostingWaypoints } from './PostingWaypoints';

function PostingViewRouteLink({
  medium,
  pickup,
  delivery,
}: PostingLoadDTO & { medium: 'list' | 'details' }) {
  const googleDirectionLink = useMemo(
    () => generateGoogleMapDirectionLink(pickup.venue, delivery.venue),
    [pickup, delivery],
  );

  return (
    <WebViewLink
      variant="body2"
      href={googleDirectionLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(event: MouseEvent) => {
        event.stopPropagation();
        trackLoadboardEvent({ medium, name: 'SLB: Clicked View Route' });
      }}
    >
      View Route
    </WebViewLink>
  );
}

interface PostingRouteInfoProps {
  load: PostingLoadDTO;
  pickupDistance?: PostingDistanceDTO | null;
  deliveryDistance?: PostingDistanceDTO | null;
  variant?: 'long';
}

export function PostingRouteInfo({
  load,
  pickupDistance,
  deliveryDistance,
  variant,
}: PostingRouteInfoProps) {
  return (
    <Stack space="xxsmall">
      <PostingWaypoints
        variant={variant}
        load={load}
        pickupDistance={pickupDistance}
        deliveryDistance={deliveryDistance}
      />
      <Inline space="xxsmall">
        <PostingViewRouteLink {...load} medium="details" />
        {load.distance_meters != null && (
          <>
            ·
            <TextBox color="secondary">
              {formatLoadDistance(load.distance_meters)}
            </TextBox>
          </>
        )}
      </Inline>
    </Stack>
  );
}
